const SelectOptionEvent = {
  fetchRooms: 'select-option/fetch-rooms',
  fetchHotels: 'select-option/fetch-hotels'
}

export default SelectOptionEvent
